import { Table, TableContainer, TableContainerProps, TableRow } from "@mui/material";
import styled from "styled-components";

interface IContainerProps {
	marginCustom?: string;
	widthCustom?: string;
}
export const Container = styled.div<IContainerProps>`
	margin: ${(props) => props.marginCustom || "2rem 0 0 0"};
	width: ${(props) => props.widthCustom || "unset"};
`;

export const Title = styled.h6`
	margin: 0 0 2rem 0;
	font-weight: bold;
	color: #000;
`;
interface IStyledTable extends TableContainerProps {
	$sizeCell: "small" | "medium" | "large";
	$typeGrid: "oddEven" | "default" | "backgroundHeader" | "backgroundBody";
	$isFixedTable?: boolean;
	$breakpointTable?: number;
}
export const StyledTable = styled(Table)<IStyledTable>`
	&&& {
		min-width: 300px;
		${({ $isFixedTable }) => $isFixedTable && "table-layout: fixed;"}
		/* Styles size cell */
    ${(props) =>
			props.$sizeCell === "small" &&
			` .MuiTableCell-root {
      padding: 0 0 0 10px;

    }
    `}

    ${(props) =>
			props.$sizeCell === "medium" &&
			`.MuiTableCell-root {
      padding: 6px 16px;
    }
  `}

  ${(props) =>
			props.$sizeCell === "large" &&
			`.MuiTableCell-root {
      padding: 10px 16px;
    }
  `}

  /* Styles type grid */
  ${({ $typeGrid }) =>
			($typeGrid === "backgroundHeader" || $typeGrid === "oddEven") &&
			`
    .MuiTableCell-head {
      background: #cccccc;
      color: #9e9e9e;
    }
  `}
  ${({ $typeGrid }) =>
			$typeGrid === "oddEven" &&
			`
    .MuiTableRow-root:nth-child(even) {
      background-color: #fff;
    }

    .MuiTableRow-root:nth-child(odd) {
      background-color: #f2f2f2;
    }
  `}
  ${({ $typeGrid, theme }) =>
			$typeGrid === "backgroundBody" &&
			`
    .MuiTableBody-root .MuiTableRow-root {
      background-color: ${theme.grayLight};
    }
  `}

  /* @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      table-layout: auto;
    } */
    @media (max-width:
    ${({ $breakpointTable }) => `${$breakpointTable}px`}) {
			table-layout: auto;
		}
	}
`;
interface IStyledTableContainer extends TableContainerProps {
	$maxHeight?: string;
}
// prettier-ignore
export const StyledTableContainer = styled(TableContainer) <IStyledTableContainer>`
  &&& {
    max-height: ${({ $maxHeight }) => $maxHeight || '100%'};

    table{
      @media (max-width: 900px) {
        width: auto;
      }
    }
  }
`;
export const BaseTableRowModalSide = styled(TableRow)`
	&&& {
		.MuiTableCell-root {
			padding: 6px 16px;
		}
	}
`;

interface IKOGTableRow {
	$isSizeLong?: boolean;
	$notClickable?: boolean;
}

export const KOGTableRow = styled(TableRow)<IKOGTableRow>`
	&&& {
		cursor: ${({ $notClickable }) => ($notClickable ? "default" : "pointer")};

		${({ $isSizeLong }) =>
			!$isSizeLong &&
			`
  .MuiTableCell-root {
    padding: 5px 20px;
  }
  `}

		&:hover {
			background-color: #f5f5f5;
		}

		@media (max-width: 600px) {
			.MuiTableCell-root {
				padding: 8px 16px;
			}
		}
	}
`;
export const KOGTableRowModalSide = styled(TableRow)<IKOGTableRow>`
	cursor: pointer;
	border-bottom: none;

	${({ $isSizeLong }) =>
		!$isSizeLong &&
		`
  .MuiTableCell-root {
    padding: 5px 20px;
    border-bottom: none;
  }
  `}

	&:hover {
		background-color: #f5f5f5;
	}

	@media (max-width: 600px) {
		.MuiTableCell-root {
			padding: 8px 16px;
		}
	}
`;

export const EndMessage = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0px;
`;
